import { getAgencyCarriers as getAgencyCarriersList } from 'src/redux/api/agency';

export const types = {
  CREATE_AGENCY: 'CREATE_AGENCY',
  UPDATE_AGENCY: 'UPDATE_AGENCY',
  SAVE_AGENCY: 'SAVE_AGENCY',
  GET_AGENCY_CARRIERS: 'GET_AGENCY_CARRIERS',
  SET_VALIDATION_ERRORS: 'SET_VALIDATION_ERRORS',
  ADD_NEW_AGENT: 'ADD_NEW_AGENT',
  UPDATE_AGENT: 'UPDATE_AGENT',
  UPDATE_AGENT_EFFECT: 'UPDATE_AGENT_EFFECT',
  DELETE_AGENT: 'DELETE_AGENT',
  SAVE_NEW_AGENT: 'SAVE_NEW_AGENT',
  SAVE_UPDATED_AGENT: 'SAVE_UPDATED_AGENT',
  SAVE_AGENT_DELETION: 'SAVE_AGENT_DELETION',
  UPDATE_AGENCY_EFFECT: 'UPDATE_AGENCY_EFFECT',
  CREATE_AGENCY_EFFECT: 'CREATE_AGENCY_EFFECT',
  DELETE_AGENT_EFFECT: 'DELETE_AGENT_EFFECT',
  ADD_NEW_AGENT_EFFECT: 'ADD_NEW_AGENT_EFFECT',
};

export const getAgencyCarriers = () => ({
  type: types.GET_AGENCY_CARRIERS,
  promise: getAgencyCarriersList(),
});

export const createAgency = (agency, nextPageUrl) => ({
  type: types.CREATE_AGENCY,
  payload: {
    agency,
    nextPageUrl,
  },
});

export const updateAgency = (agency, options = {}) => ({
  type: types.UPDATE_AGENCY,
  payload: {
    agency,
    options,
  },
});

export const updateAgencyEffect = (agency, options = {}) => ({
  type: types.UPDATE_AGENCY_EFFECT,
  payload: {
    agency,
    options,
  },
  formName: options.formName,
  navigationDisabled: options.navigationDisabled,
});

export const createAgencyEffect = (agent, options = {}, nextUrl) => ({
  type: types.CREATE_AGENCY_EFFECT,
  payload: {
    agent,
    nextUrl,
  },
  formName: options.formName,
});

export const saveAgency = agency => ({
  type: types.SAVE_AGENCY,
  payload: {
    agency,
  },
});

export const setValidationErrors = errors => ({
  type: types.SET_VALIDATION_ERRORS,
  payload: {
    errors,
  },
});

export const addNewAgent = agent => ({
  type: types.ADD_NEW_AGENT,
  payload: {
    agent,
  },
});

export const updateAgent = (agent, nextUrl) => ({
  type: types.UPDATE_AGENT,
  payload: {
    agent,
    nextUrl,
  },
});

export const deleteAgentEffect = agent => ({
  type: types.DELETE_AGENT_EFFECT,
  payload: {
    agent,
  },
});

export const saveNewAgent = agent => ({
  type: types.SAVE_NEW_AGENT,
  payload: {
    agent,
  },
});

export const saveUpdatedAgent = agent => ({
  type: types.SAVE_UPDATED_AGENT,
  payload: {
    agent,
  },
});

export const saveAgentDeletion = agent => ({
  type: types.SAVE_AGENT_DELETION,
  payload: {
    agent,
  },
});
